export default __webpack_public_path__ + "static/media/CV1.5159872c.png";